import moment from 'moment';
import formatIsoDate from '@/services/general/formatIsoDate';

export default function dateStringToIso(dateString) {
  const date = moment(dateString, 'DD/MM/YYYY');
  if (date.isValid()) {
    return formatIsoDate(date);
  }
  return dateString;
}
